/** Help Center (Zendesk) — replaces in-app `/faq/` and `/men/faq/` links. */
export const HELP_CENTER_FAQ_URL = "https://help.nutrafol.com/hc/en-us";
